export default __webpack_public_path__ + "static/media/asistence-tone.f4aa43b9.mp3";